import { TabbedContainer } from "capitalrx-components-2.0/lib/general";
import styled from "styled-components";

export const ThemedTabbedContainer = styled(TabbedContainer)`
  .indicator {
    background-color: ${(props) => props.theme.primary_button_color};
  }

  .tab-panel {
    padding: 2rem 0 0;
    .panel {
      margin-top: 0;
    }
  }
`;
